import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const Section = styled.section`
	width: 90%;
	margin-top: 24px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const SectionHeader = styled.button`
	display: flex;
	justify-self: flex-start;
	align-self: flex-start;
	justify-content: flex-start;
	align-items: center;
	gap: 10px;
	width: auto;
	color: ${Colors.darkBlue};
	background-color: transparent;
	border: none;
	padding: 10px 14px;
	cursor: pointer;
	font-size: 32px;
	font-weight: 500;
`;

export const TableWrapper = styled.div`
	max-height: calc(100vh - 250px);
	overflow: auto;
	margin-top: 8px;
	display: flex;
	justify-content: center;
`;

export const GroupRow = styled.tr`
	background-color: ${Colors.lightBlue2};
	cursor: pointer;
	font-weight: 700;
`;

export const SummaryRow = styled.tr`
	background-color: ${Colors.newBlue};
	font-weight: 700;
`;

export const ResultRow = styled.tr`
	background-color: ${Colors.red};
`;

export const ConfirmActions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	margin-top: 16px;
`;
